import React from 'react';
import { OutputColumn } from '../columns';
import { Cell } from './Cell';
import { TextItem } from 'domains/designers/TruthTable/components';

interface IIgnoreCellProps extends React.HTMLProps<HTMLTableDataCellElement> {}

/**
 * Represent ignored value in cell.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function IgnoreCell(props: IIgnoreCellProps = {}) {
  return (
    <OutputColumn {...props}>
      <Cell>
        <TextItem>--------------------</TextItem>
      </Cell>
    </OutputColumn>
  );
}
